import styled from 'styled-components';
import { Text } from '@bufferapp/ui';

export const ModalBody = styled(Text)`
  padding: 16px 16px 0 16px;
  margin: 0;
`;
